import { SetAlert } from "components/Alerts/actions";
import { SetTaskComplete } from "components/Task/actions";

import {
  GetAllClients,
  SetActiveClients,
  SetAllClientNames,
  SetRecentClientNames,
} from "./clients/actions";
import {
  GetAllClientWorkflows,
  SetClientWorkflows,
} from "./clientWorkflows/actions";
import { FetchHubHouseholds, SetHouseholds } from "./households/actions";
import { SetTags } from "./tags/actions";
import { SetWorkflows } from "./workflows/actions";
import { ClearFilters } from "../filters/actions";
import { GetAllClientNames, GetRecentClientNames } from "../libs/clients";
import { GetHouseholds } from "../libs/households";
import { GetHub, SetHubPreferences } from "../libs/hubs";
import { GetReminders } from "../libs/reminders";
import { GetTags } from "../libs/tags";
import { GetViews } from "../libs/views";
import { GetWorkflows } from "../libs/workflows";
import { SetReminders } from "../reminders/actions";
import { SetViews } from "../views/actions";
import { SetWebsocketHubId } from "../websockets/actions";

export const SetHubLoading = (loading) => {
  return {
    type: "SET_HUB_LOADING",
    loading: loading,
  };
};

export const SetInProgress = (inProgress, percent) => {
  return {
    type: "SET_IN_PROGRESS",
    inProgress: inProgress,
    percent: percent,
  };
};

export function CompleteTaskByReminder(taskId, clientId, onSuccess = () => {}) {
  return (dispatch, getState) => {
    const client = getState().hubly.data.hub.clients.activeClients[clientId];
    const { clientWorkflows } = getState().hubly.data.hub;

    const clientWorkflowId = client.workflows.find((workflowId) => {
      return clientWorkflows[workflowId].tasks.some((task) => {
        return task.id === taskId;
      });
    });

    if (!clientWorkflowId || !clientWorkflows[clientWorkflowId]) {
      console.warn(
        `Could not find client workflow for task ${taskId} on client ${clientId}`
      );
      return;
    }

    dispatch(
      SetTaskComplete(clientWorkflows[clientWorkflowId], taskId, null, () => {
        dispatch(
          SetAlert({
            type: "success",
            text: `Successfully completed task by reminder`,
          })
        );

        onSuccess();
      })
    );
  };
}

export const SetHub = (hub) => {
  return {
    type: "SET_HUB",
    hub: hub,
  };
};

export const SetHubToLoad = (hub) => {
  return (dispatch) => {
    dispatch(SetHub(hub));
    dispatch(SetWebsocketHubId(hub.hubId));
    dispatch({ type: "SET_PENDING_LOAD_RESOURCES", set: true });
  };
};

export const LoadHubResources = () => {
  return (dispatch, getState) => {
    const { hub } = getState().hubly.data.hub.selected;

    dispatch(SetReminders([]));
    dispatch(SetHubLoading(true));
    dispatch(SetHub(hub));
    const getWorkflowsPromise = GetWorkflows(hub).then((resp) => {
      dispatch(SetWorkflows(resp));
      // Initial state has no workflows set for filters, if that's the case, set them here

      const { filters } = getState().hubly.data;
      if (
        !filters.workflows ||
        filters.workflows.find((w) => {
          return w.id !== resp[0].id;
        })
      ) {
        dispatch(ClearFilters(resp));
      }
    });

    const { loadAllClientsOnStartup = true } = hub.preferences || {};

    const getClientsPromise = loadAllClientsOnStartup
      ? GetAllClients(hub).then((resp) => {
          dispatch(SetActiveClients(resp));
        })
      : Promise.resolve();

    const getTagsPromise = GetTags(hub).then((resp) => {
      const tags = {};
      resp.forEach((tag) => {
        tags[tag.id] = tag;
      });
      dispatch(SetTags(tags));
    });
    const getClientNamesPromise = GetAllClientNames(hub).then((resp) => {
      dispatch(SetAllClientNames(resp));
    });
    const getRecentClientNamesPromise = GetRecentClientNames(hub).then(
      (resp) => {
        dispatch(SetRecentClientNames(resp));
      }
    );
    const getClientWorkflowsPromise = GetAllClientWorkflows(hub).then(
      (response) => {
        dispatch(SetClientWorkflows(response));
      }
    );
    const getHouseholdsPromise = GetHouseholds(hub).then((response) => {
      dispatch(SetHouseholds(response));
    });
    const getViewsPromise = GetViews(hub).then((response) => {
      dispatch(SetViews(response));
    });
    const getRemindersPromise = GetReminders(hub, {
      client_id__isnull: false,
      limit: 999999999,
      ordering: "time",
      active: true,
    }).then((response) => {
      SetReminders(response.results);
    });

    const promises = [
      getWorkflowsPromise,
      getClientsPromise,
      getTagsPromise,
      getClientNamesPromise,
      getRecentClientNamesPromise,
      getClientWorkflowsPromise,
      getHouseholdsPromise,
      getViewsPromise,
      getRemindersPromise,
    ];

    Promise.all(promises).then(() => {
      dispatch(SetHubLoading(false));
      dispatch(SetWebsocketHubId(hub.hubId));
      dispatch({ type: "SET_PENDING_LOAD_RESOURCES", set: false });
    });
  };
};

const SetNewHubPreferences = (hub) => {
  return {
    type: "SET_HUB_PREFERENCES",
    preferences: hub.preferences,
  };
};

export const SetSelectedHubPreferences = (newSettings) => {
  return async (dispatch, getState) => {
    const hubId = getState().hubly.data.hub.selected.hub.id;

    try {
      await SetHubPreferences(hubId, newSettings);
      dispatch(SetNewHubPreferences(await GetHub(hubId)));
    } catch (error) {
      dispatch(SetAlert({ type: "error", text: "Failed save your settings." }));
    }
  };
};

/*
 * THIS IS A TEMPORARY SOLUTION FOR LOADING UNPAGINATED RESOURCES
 *
 * ANY CALL WITHIN THIS FUNCTION SHOULD BE CONVERTED TO A PAGINATED CALL
 * THAT THE GRAPHICAL COMPOENENT WOULD KNOW TO HANDLE
 *
 */
export const LoadMinimizeHubResources = () => {
  return (dispatch, getState) => {
    const { households, householdLoader } = getState().hubly.data.hub;
    const { fetching } = householdLoader;

    if (households.isEmpty && !fetching) dispatch(FetchHubHouseholds());
  };
};

export const SetHubNeedSetup = (needSetup) => {
  return { type: "SET_HUB_NEED_SETUP", needSetup: needSetup };
};

export const SetHubUseCasesVisibility = (visible) => {
  return { type: "SET_HUB_USE_CASES_VISIBILITY", visible: visible };
};
